
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatstory/[chapterId]",
      function () {
        return require("private-next-pages/chatstory/[chapterId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatstory/[chapterId]"])
      });
    }
  